import Vue from 'vue';
import User from './user';

Vue.use(User);